import rangeSlider from "./loanCalculator/rangeslider"
import './components/decimal-seperator'
import './bootstrap.js'

console.log('james')

$(function () {

	$('.eier').hide();
	$('.leier').hide();

	$('#LoanBasketFormModelNO_HouseType').change(function () {
		var value = $(this).find('option:selected').val();
		if (value == 'Eier bolig') {
			$('.eier').show();
			$('.leier').show();
		} else if (value == 'Leier bolig') {
			$('.leier').show();
			$('.eier').hide();
		}
	});

	$('.cardata').hide();

	$('#LoanBasketFormModelNO_CarOptions').change(function () {
		var value = $(this).find('option:selected').val();
		if (value == 'Ja') {
			$('.cardata').show();
		} else if (value == 'Nei') {
			$('.cardata').hide();
		}
	});

	$('.studentdata').hide();

	$('#LoanBasketFormModelNO_StudentOptions').change(function () {
		var value = $(this).find('option:selected').val();
		if (value == 'Ja') {
			$('.studentdata').show();
		} else if (value == 'Nei') {
			$('.studentdata').hide();
		}
	});


	$('.loandata').hide();

	$('#LoanBasketFormModelNO_LoanOptions').change(function () {
		var value = $(this).find('option:selected').val();
		if (value == 'Ja') {
			$('.loandata').show();
		} else if (value == 'Nei') {
			$('.loandata').hide();
		}
	});


	//$('.eier').hide();
	//$('.leier').hide();
	//$('.carloan').hide();
	//$('.studentloan').hide();
	//$('.otherloan').hide();

	//$('#ctl00_ctl29_loan_no_ddHouseType').change(function () {
	//	var value = $(this).find('option:selected').val();
	//	console.log('test');
	//	if (value == 'Eier bolig') {
	//		$('.eier').show();
	//		$('.leier').hide();
	//	} else if (value == 'Leier bolig') {
	//		$('.leier').show();
	//		$('.eier').hide();
	//	} else if (value == '') {
	//		$('.leier').hide();
	//		$('.eier').hide();
	//	}
	//});


	//if ($('#ctl00_ctl29_loan_no_ddHouseType').find('option:selected').val() == 'Eier bolig') {
	//	$('.eier').show();
	//	$('.leier').hide();
	//}

	//if ($('#ctl00_ctl29_loan_no_ddHouseType').find('option:selected').val() == 'Leier bolig') {
	//	$('.leier').show();
	//	$('.eier').hide();
	//}


	//$('#ctl00_ctl29_loan_no_ddlCarloan').change(function () {
	//	var value = $(this).find('option:selected').val();

	//	if (value == '1') {
	//		$('.carloan').show();
	//	} else if (value == '0') {
	//		$('.carloan').hide();
	//	} else if (value == '-1') {
	//		$('.carloan').hide();
	//	}
	//});

	//if ($('#ctl00_ctl29_loan_no_ddlCarloan').find('option:selected').val() == '1') {
	//	$('.carloan').show();
	//}

	//$('#ctl00_ctl29_loan_no_ddlStudentLoan').change(function () {
	//	var value = $(this).find('option:selected').val();

	//	if (value == '1') {
	//		$('.studentloan').show();
	//	} else if (value == '0') {
	//		$('.studentloan').hide();
	//	} else if (value == '-1') {
	//		$('.studentloan').hide();
	//	}
	//});

	//if ($('#ctl00_ctl29_loan_no_ddlStudentLoan').find('option:selected').val() == '1') {
	//	$('.studentloan').show();
	//}

	//$('#ctl00_ctl29_loan_no_ddlOtherLoan').change(function () {
	//	var value = $(this).find('option:selected').val();

	//	if (value == '1') {
	//		$('.otherloan').show();
	//	} else if (value == '0') {
	//		$('.otherloan').hide();
	//	} else if (value == '-1') {
	//		$('.otherloan').hide();
	//	}
	//});

	//if ($('#ctl00_ctl29_loan_no_ddlOtherLoan').find('option:selected').val() == '1') {
	//	$('.otherloan').show();
	//}



	////windows phone 7/8  Bootstrap fix
	//if ("-ms-user-select" in document.documentElement.style && navigator.userAgent.match(/IEMobile\/10\.0/)) {
	//	var msViewportStyle = document.createElement("style");
	//	msViewportStyle.appendChild(
	//		document.createTextNode("@-ms-viewport{width:auto!important}")
	//	);
	//	document.getElementsByTagName("head")[0].appendChild(msViewportStyle);
	//}

	////detect browsers
	//var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
	//var is_explorer = navigator.userAgent.indexOf('MSIE') > -1;
	//var is_firefox = navigator.userAgent.indexOf('Firefox') > -1;
	//var is_safari = navigator.userAgent.indexOf("Safari") > -1;
	//var is_Opera = navigator.userAgent.indexOf("Presto") > -1;
	//if ((is_chrome) && (is_safari)) {
	//	is_safari = false;
	//}
	//if (!is_safari && !is_chrome) {
	//	$('#content .col-right .formular .padding .button .text').css('margin-top', '1px');
	//	$('#content .col-right .formular .padding .button .arrow').css('margin-top', '2px');
	//}
	//if (is_safari) {
	//	$('#content .col-right .formular .padding .button .text').css('margin-top', '-1px');
	//	$('#content .col-right .formular .padding .button .arrow').css('margin-top', '-2px');
	//}
	//if (is_explorer) {
	//	$('#content .col-right .formular .padding .button .text').css('margin-top', '2px');
	//	$('#content .col-right .formular .padding .button .arrow').css('margin-top', '2px');
	//}


	//// bg-split
	//$('#bg-split').css('background-position', $('#bg-split').width() - 320 - 252 + 'px' + ' 125px');

	//// select boxes
	//$('#content .col-right .formular .padding .styled-select select').each(function (e) {
	//	var selE = $('select:eq(' + e + ') option:selected').text();
	//	$(this).wrap('<div class="selectWrap"></div>');
	//	$('.selectWrap:eq(' + e + ')').append('<span class="selectInner"></span>');
	//	$('.selectInner:eq(' + e + ')').text(selE);
	//});
	//$('#content .col-right .formular .padding .styled-select select').change(function () {
	//	var i = $(this).index('select');
	//	var sel = $('select:eq(' + i + ') option:selected').text();
	//	$('.selectInner:eq(' + i + ')').text(sel);
	//});

	// validate function
	//$('.formular .padding button').click(function (e) {
	//	var form = $('form');
	//	return validate_form(form);
	//});

	//// placeholders
	//$('[placeholder]').focus(function() {

	//	var input = $(this);
	//	if (input.val() == input.attr('placeholder')) {
	//		input.val('');
	//		input.removeClass('placeholder');
	//	}

	//}).blur(function() {

	//	var input = $(this);
	//	if (input.val() == '' || input.val() == input.attr('placeholder')) {
	//		input.addClass('placeholder');
	//		input.val(input.attr('placeholder'));
	//	}

	//}).blur().parents('form').submit(function() {

	//	$(this).find('[placeholder]').each(function() {
	//		var input = $(this);
	//		if (input.val() == input.attr('placeholder')) {
	//			input.val('');
	//		}
	//	})

	//});



	// placeholders
	//if ($(window).width() < 768) {
	//	$('[placeholder]').focus(function () {

	//		var input = $(this);
	//		if (input.val() == input.attr('placeholder')) {
	//			input.val('');
	//			input.removeClass('placeholder');
	//		}

	//	}).blur(function () {

	//		var input = $(this);
	//		if (input.val() == '' || input.val() == input.attr('placeholder')) {
	//			input.addClass('placeholder');
	//			input.val(input.attr('placeholder'));
	//		}

	//	}).blur().parents('form').submit(function () {

	//		$(this).find('[placeholder]').each(function () {
	//			var input = $(this);
	//			if (input.val() == input.attr('placeholder')) {
	//				input.val('');
	//			}
	//		});
	//	});
	//}

	// placeholders formular
	//if ($(window).width() > 767) {
	//	$('#content.page .text .section .row input[type="text"]').each(function () {
	//		$(this).not('.regnr, .kontonr').attr('placeholder', '');
	//	});
	//} else {
	//	$('#content.page .text .section .row input[type="text"]').each(function () {
	//		$(this).not('.regnr, .kontonr').attr('placeholder', $(this).attr('data-placeholder'));
	//	});
	//}


	var hostname = window.location.hostname;
	var loaddata = "";

	// calculator
	var parsedJSON = '';

	// start values
	if ($('input.calc-hidden-amount').length > 0) {
		amount = $('input.calc-hidden-amount').val().replace('.', '');
		amountMin = $('input.calc-hidden-amount-min').val().replace('.', '');
		amountMax = $('input.calc-hidden-amount-max').val().replace('.', '');
		months = $('input.calc-hidden-months').val();
		monthsMin = $('input.calc-hidden-months-min').val();
		monthsMax = $('input.calc-hidden-months-max').val();


		$('select.calc-amount-xs').val(amount).change();
		$('select.calc-months-xs').val(months).change();

		$('input.calc-hidden-amount').val(amount);
		$('input.calc-hidden-months').val(months);

		if ($('select.calc-months-xs').val() > 60) {
			var dutySlider = $('.years5');
			$(dutySlider).show();
		}

		if ($("#slider-amount").length > 0 && $("#slider-months").length > 0) {
			if (hostname.indexOf('klicklan.se') > -1 || hostname.indexOf('klicklan.local') > -1)
				loaddata = '/files/kliklaan/loaddata_se.json'

			if (hostname.indexOf('klikklan.no') > -1 || hostname.indexOf('klikklan.local') > -1)
				loaddata = '/files/kliklaan/loaddata_no.json'

			if (hostname.indexOf('kliklaan.dk') > -1 || hostname.indexOf('kliklaan.local') > -1)
				loaddata = '/files/kliklaan/loaddata_dk.json'

			$.getJSON(loaddata, function (data) {

				parsedJSON = data;

				for (var i = 0; i < parsedJSON.months.length; i++) {
					if (parsedJSON.months[i].month == months && parsedJSON.months[i].amount == amount) {
						setCalculatedValues(parsedJSON.months[i].amount, parsedJSON.months[i].month, parsedJSON.months[i].monthlyPay, parsedJSON.months[i].debitrente, parsedJSON.months[i].creditTotal, parsedJSON.months[i].aop, parsedJSON.months[i].totalkreditcost, parsedJSON.months[i].kreditcost, parsedJSON.months[i].setupfeeloan, parsedJSON.months[i].maxrente);
					}
				}

				$("#slider-amount").slider({
					value: parseFloat(amount),
					min: parseFloat(amountMin),
					max: parseFloat(amountMax),
					step: 1000,
					slide: function (event, ui) {
						$('select.calc-amount-xs option[value="' + ui.value.toString() + '"]').prop('selected', true);
						$('#slider-amount .tooltip-custom').html(displayAmount(ui.value.toString()));
						$('.calc-amount-xs').parent().find('.selectInner').html(displayAmount(ui.value.toString()));
						$('input.calc-hidden-amount').val(ui.value.toString());
						for (var i = 0; i < parsedJSON.months.length; i++) {
							if (parsedJSON.months[i].amount == ui.value.toString() && parsedJSON.months[i].month == $('input.calc-hidden-months').val()) {
								setCalculatedValues(parsedJSON.months[i].amount, parsedJSON.months[i].month, parsedJSON.months[i].monthlyPay, parsedJSON.months[i].debitrente, parsedJSON.months[i].creditTotal, parsedJSON.months[i].aop, parsedJSON.months[i].totalkreditcost, parsedJSON.months[i].kreditcost, parsedJSON.months[i].setupfeeloan, parsedJSON.months[i].maxrente);
							}
						}
					}
				});

				$("#slider-months").slider({
					value: parseFloat(months),
					min: parseFloat(monthsMin),
					max: parseFloat(monthsMax),
					step: 1,
					slide: function (event, ui) {
						$('select.calc-months-xs option[value="' + ui.value.toString() + '"]').prop('selected', true);
						$("#slider-months .tooltip-custom").html(ui.value + $('.calc-hidden-months-txt').val());
						$('.calc-months-xs').parent().find('.selectInner').html(ui.value + $('.calc-hidden-months-txt').val());
						$('input.calc-hidden-months').val(ui.value);
						for (var i = 0; i < parsedJSON.months.length; i++) {
							if (parsedJSON.months[i].month == ui.value && parsedJSON.months[i].amount == $('input.calc-hidden-amount').val()) {
								setCalculatedValues(parsedJSON.months[i].amount, parsedJSON.months[i].month, parsedJSON.months[i].monthlyPay, parsedJSON.months[i].debitrente, parsedJSON.months[i].creditTotal, parsedJSON.months[i].aop, parsedJSON.months[i].totalkreditcost, parsedJSON.months[i].kreditcost, parsedJSON.months[i].setupfeeloan, parsedJSON.months[i].maxrente);
							}
						}

						var dutySlider = $('.years5');
						if (ui.value > 60) {
							$(dutySlider).show();
						}
						if (ui.value < 61) {
							$(dutySlider).hide();
						}
					}

				});

				$('.ui-slider-handle').html('<div class="tooltip-custom"></div>');
				$("#slider-amount .tooltip-custom").html(displayAmount(amount));
				$("#slider-months .tooltip-custom").html(months + $('.calc-hidden-months-txt').val());
				$('.ui-slider-handle').on('mouseenter', function () {
					$(this).find('.tooltip-custom').fadeIn(500);
				});

			});

			$('select.calc-amount-xs').on('change', function () {
				$("#slider-amount").slider("option", "value", $(this).val());
				amount = $(this).val();
				$("#slider-amount .tooltip-custom").html(amount + ' kr.');
				$('input.calc-hidden-amount').val(amount);
				for (var i = 0; i < parsedJSON.months.length; i++) {
					if (parsedJSON.months[i].amount == amount && parsedJSON.months[i].month == $('input.calc-hidden-months').val()) {
						setCalculatedValues(parsedJSON.months[i].amount, parsedJSON.months[i].month, parsedJSON.months[i].monthlyPay, parsedJSON.months[i].debitrente, parsedJSON.months[i].creditTotal, parsedJSON.months[i].aop, parsedJSON.months[i].totalkreditcost, parsedJSON.months[i].kreditcost, parsedJSON.months[i].setupfeeloan, parsedJSON.months[i].maxrente);
					}
				}
			});

			$('select.calc-months-xs').on('change', function () {
				$("#slider-months").slider("option", "value", $(this).val());
				months = $(this).val();
				$("#slider-months .tooltip-custom").html(months + $('.calc-hidden-months-txt').val());
				$('input.calc-hidden-months').val(months);
				for (var i = 0; i < parsedJSON.months.length; i++) {
					if (parsedJSON.months[i].month == months && parsedJSON.months[i].amount == $('input.calc-hidden-amount').val()) {
						setCalculatedValues(parsedJSON.months[i].amount, parsedJSON.months[i].month, parsedJSON.months[i].monthlyPay, parsedJSON.months[i].debitrente, parsedJSON.months[i].creditTotal, parsedJSON.months[i].aop, parsedJSON.months[i].totalkreditcost, parsedJSON.months[i].kreditcost, parsedJSON.months[i].setupfeeloan, parsedJSON.months[i].maxrente);
					}
				}
				var dutySlider = $('.years5');
				if (months >= 60) {
					$(dutySlider).show();
				}
				if (months < 61) {
					$(dutySlider).hide();
				}

			});
		}
	}
});

// set calculated text fields
function setCalculatedValues(amount, month, monthlyPay, debitrente, creditTotal, aop, totalkreditcost, kreditcost, setupfeeloan, maxrente) {
	$(".calc-amount").html(amount);
	$(".calc-month").html(month);
	$(".calc-monthlyPay").html(monthlyPay);
	setPayment(monthlyPay);
	$(".calc-debitrente").html(debitrente);
	$(".calc-maxrente").html(maxrente);
	$(".calc-creditTotal").html(creditTotal);
	$(".calc-aop").html(aop);
	$(".calc-totalkreditcost").html(totalkreditcost);
	$(".calc-kreditcost").html(kreditcost);
	$(".calc-setupfeeloan").html(setupfeeloan);
}


// convert amount from ui-sliders before insert
function displayAmount(amount) {
	var textvalue = $('.calc-hidden-currency').val();
	textvalue = textvalue.replace("###", amount.slice(amount.length - 3, 5));
	textvalue = textvalue.replace("#", amount.slice(0, amount.length - 3));

	return textvalue;
}

function setPayment(payment) {

	payment = payment.replace(" ", "");
	payment = payment.replace(".", "");
	payment = payment.replace(",-", "");
	payment = payment.replace(":-", "");
	payment = payment.replace("kr.", "");
	payment = payment.replace(" ", "");
	$('.calc-hidden-months-payment').val(payment);
}

// generel form validation
//function validate_form(form) {
//	var Valid = true;
//	var Message = '';
//	form.find('.validate, .validate-checkbox').removeClass('error');
//	form.find('.validate').each(function () {
//		if ($(this).hasClass('required') && $(this).val().trim() == '' || $(this).hasClass('required') && $(this).val().trim() == $(this).attr('placeholder')) {
//			Valid = false;
//			Message += $(this).attr('data-alert') + '\n';
//			$(this).addClass('error');
//		}
//		if ($(this).hasClass('email')) {
//			var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
//			if (!reg.test($(this).val())) {
//				Valid = false;
//				Message = Message + $(this).attr('data-alert') + '\n';
//				$(this).addClass('error');
//			}
//		}
//		if ($(this).hasClass('number')) {
//			if (isNaN(parseFloat($(this).val().trim()))) {
//				Valid = false;
//				Message = Message + $(this).attr('data-alert') + '\n';
//				$(this).addClass('error');
//			}
//		}
//	});
//	var checkbox = false;
//	form.find('.validate-checkbox').each(function () {
//		$(this).find('input[type="checkbox"]').each(function () {
//			if ($(this).prop('checked')) {
//				checkbox = true;
//			}
//		});
//		if (checkbox == false) {
//			Valid = false;
//			Message = Message + $(this).attr('data-alert') + '\n';
//			$(this).addClass('error');
//		}
//	});
//	if (!Valid) {
//		if (form.find('.hidden-form').is(':hidden')) {
//			form.find('.hidden-form').fadeIn(500);
//		}
//		alert(Message);
//		return false
//	}
//	if (Valid) {
//		// send information
//		form.submit();
//	}
//}

// window resize
$(window).resize(function () {
	// bg-split
	$('#bg-split').css('background-position', $('#bg-split').width() - 320 - 252 + 'px' + ' 125px');

	// placeholders formular
	if ($(window).width() > 767) {
		$('#content.page .text .section .row input[type="text"]').each(function () {
			$(this).not('.regnr, .kontonr').attr('placeholder', '');
		});
	} else {
		$('#content.page .text .section .row input[type="text"]').each(function () {
			$(this).not('.regnr, .kontonr').attr('placeholder', $(this).attr('data-placeholder'));
		});
	}
});

// link to retina images
if (window.devicePixelRatio >= 1.5) {
	var images = $('img.retina');
	// loop through the images and make them hi-res
	for (var i = 0; i < images.length; i++) {
		console.log('-rt');
		// create new image name
		var imageType = images[i].src.substr(-4);
		var imageName = images[i].src.substr(0, images[i].src.length - 4);
		imageName += '-rt' + imageType;
		//rename image
		images[i].src = imageName;
	}
}



// $(function () {
// 	$('[data-toggle="tooltip"]').tooltip()
// });

// $(function () {
// 	$('i.icon-info').click(function () {
// 		alert('smink');
// 		$(this).parent().find('.tool-tip').css("display", "block;");
// 	}, function () {
// 		$(this).parent().find('.tool-tip').css("display", "none;");
// 	});
// });

$('i.icon-info').click(function () {
	var parent = $(this).parent();
	var children = parent.find('.tool-tip');
	if (children.is(":visible")) {
		children.hide();
	} else {
		children.show();
	}
});

let tooltips = document.querySelectorAll('.tool-tip');

if (tooltips) {

	for (let i = 0; i < tooltips.length; i++) {

		let input = tooltips[i].nextElementSibling;

		input.addEventListener('focus', function () {
			if (input.type != 'radio') {
				tooltips[i].style.display = "block";
			}
		})

		input.addEventListener('blur', function () {

			if (input.type != 'radio') {
				tooltips[i].style.display = "none";
			}
		})
	}
}